import { OnInit, AfterViewInit, Component} from '@angular/core';
import { AppComponent } from '../app.component';
import { SweetServices } from '../../services/sweet.services';
import { SessionSotrageService } from 'src/services/session-sotrage.service';
import { ValidarTokenGuard } from 'src/guards/validartoken.guard';

@Component({
	selector: 'app-main',
	templateUrl: './pages.component.html',
	styleUrls: [],
})
export class PagesComponent implements OnInit, AfterViewInit {
	private activeAlert: number;
	constructor(
		private loading: AppComponent, 
		private alerta: SweetServices, 
		private ssstorage: SessionSotrageService, 
		private validaToken: ValidarTokenGuard) {
		loading.loading = true;
		this.loadScript('assets/js/script.js');
		this.loadScript('assets/js/pcoded.min.js');
		this.loadScript('assets/js/demo-12.js');
		this.loadScript('assets/js/jquery.mCustomScrollbar.concat.min.js');
		this.loadScript('assets/js/jquery.mousewheel.min.js');
	}

	ngOnInit() {
		this.verificacion();
	}

	ngAfterViewInit() {
		this.loading.loading = false;
	}

	verificacion() {
		let intervalId = setInterval(() => {
			if (!this.validarToken()) {
				clearInterval(intervalId);
			}
		}, 1500);
	}

	validarToken(): Promise<boolean> | boolean {
		let result = true;
		let token = this.ssstorage.getCurrentToken();
		if (token != null) {
		  let payload = JSON.parse(atob(token.split('.')[1]));
		  let expirado = this.validaToken.expiro(payload.exp);
		  this.activeAlert = this.ssstorage.getActivateAlert();
		  if (expirado) {
			this.alerta.AlertaRecargarToken();
			result = false;
		  }
		} else {
		  result = false;
		}
		return result
	  }

	public loadScript(url: string) {
		const body = document.body as HTMLDivElement;
		const script = document.createElement('script');
		script.innerHTML = '';
		script.src = url;
		script.async = false;
		script.defer = true;
		body.appendChild(script);
	}
}
